export class ProgettoReworked {
  id: number;
  versione: number;
  dataCreazione: Date;
  idProgettista: string;
  nomeProgettista: string;
  note: string;
  delivered: boolean;
}
